/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactSearchResponse } from '../../models/contact-search-response';

export interface GetContactsSearch$Params {
  query: string;
}

export function getContactsSearch(http: HttpClient, rootUrl: string, params: GetContactsSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContactSearchResponse>>> {
  const rb = new RequestBuilder(rootUrl, getContactsSearch.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ContactSearchResponse>>;
    })
  );
}

getContactsSearch.PATH = '/contacts/search';
